import React from 'react';
import type { CartItemGroupRendererProps } from './cart-items.types';
import { CartItemGroup, type CartItemGroupProps } from '../cart-item-group/cart-item-group';
import type { CartItemGroupProps as BaseCartItemGroupProps } from '@kidslabs/mario-nextjs-react-ui-core';

/**
 * CartItemGroupRenderer - Wrapper component matching mobile pattern
 *
 * Renders each cart item reference group with a wrapper div for styling
 * Passes props through to CartItemGroup component
 *
 * @see mobile-ecommerce/applications/module-quote/src/components/cart-items/cart-item-group-renderer.tsx
 */
export const CartItemGroupRenderer: React.FC<CartItemGroupRendererProps> = ({
    cartItemReference,
    cartId,
    showOnlySelected,
    cartItemWrapperStyle,
    counterButton,
    variantCounterButton,
    variantCartItemV2,
    variantSizePriceBox,
    variantCartItemGroup,
    expanded,
    CartItemGroupComponent,
    cartCounterButtonProps,
    onItemPressed,
    onSelected,
    onUnSelected,
    onRightActionPressed,
    onOutOfStockPress,
    isSwipeable,
}) => {
    if (!cartItemReference.cartItem) {
        return null;
    }

    // Use custom component or default CartItemGroup
    const CartItemGroupToRender = CartItemGroupComponent || CartItemGroup;
    // Type assertions needed because module-quote uses specific types while UI Core uses base types
    return (
        <div className={cartItemWrapperStyle}>
            <CartItemGroupToRender
                variantCounterButton={variantCounterButton}
                variantCartItemV2={variantCartItemV2}
                variantSizePriceBox={variantSizePriceBox}
                variantCartItemGroup={variantCartItemGroup}
                cartId={cartId}
                showOnlySelected={showOnlySelected}
                disabled={false}
                expanded={expanded}
                isSwipeable={isSwipeable}
                onItemPressed={onItemPressed as unknown as BaseCartItemGroupProps['onItemPressed']}
                onSelected={onSelected as unknown as BaseCartItemGroupProps['onSelected']}
                onUnSelected={onUnSelected as unknown as BaseCartItemGroupProps['onUnSelected']}
                cartCounterButtonProps={
                    counterButton ? (cartCounterButtonProps as CartItemGroupProps['cartCounterButtonProps']) : undefined
                }
                onRightActionPressed={onRightActionPressed as unknown as BaseCartItemGroupProps['onRightActionPressed']}
                cartItemReference={cartItemReference}
                onOutOfStockPress={onOutOfStockPress as unknown as BaseCartItemGroupProps['onOutOfStockPress']}
                counterButton={counterButton}
            />
        </div>
    );
};
